import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { fmtDuration } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { CourseThumb } from "../lib/art";

export default function MyLearning() {
  const [items, setItems] = useState(null);
  const { sections } = useStore();
  const secMap = Object.fromEntries(sections.map((s) => [s.id, s]));

  useEffect(() => { api.get("/my-learning").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div className="wrap cart-page">
      <h1 data-testid="my-learning-title">MY LEARNING</h1>
      <p className="sub">{items ? `${items.length} enrolled course${items.length !== 1 ? "s" : ""}` : ""}</p>
      {items === null ? <p style={{ color: "var(--muted)" }}>Loading…</p> : items.length === 0 ? (
        <div className="empty" data-testid="no-enrollments">You're not enrolled in any courses yet.<br /><br />
          <Link to="/courses" className="btn-primary">Browse Courses</Link></div>
      ) : (
        <div className="results-grid">
          {items.map(({ course: c, progress_pct, last_lecture_id }) => (
            <div key={c.id} className="card" data-testid={`learning-card-${c.id}`} style={{ "--glow": "var(--bp)" }}>
              <Link to={`/learn/${c.id}`} style={{ textDecoration: "none" }}>
                <div className="thumb">
                  <CourseThumb course={c} color={secMap[c.section]?.color} />
                  <div className="play"><div className="play-btn"><svg width="18" height="18" viewBox="0 0 24 24" fill="#04121f"><path d="M8 5v14l11-7z" /></svg></div></div>
                </div>
                <div className="card-body">
                  <h3>{c.title}</h3>
                  <div className="meta-line">{c.lecture_count} lectures · {fmtDuration(c.total_duration_min)}</div>
                  <div style={{ height: 6, background: "var(--line)", borderRadius: 3, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${progress_pct}%`, background: "var(--land)", borderRadius: 3, transition: "width .4s" }} />
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, fontSize: 12 }}>
                    <span style={{ color: "var(--land)" }} data-testid={`progress-${c.id}`}>{progress_pct}% complete</span>
                    <span style={{ color: "var(--bp)", fontFamily: "var(--font-d)" }}>{last_lecture_id ? "RESUME →" : "START →"}</span>
                  </div>
                </div>
              </Link>
              {progress_pct === 100 && (
                <Link to={`/certificate/${c.id}`} data-testid={`certificate-link-${c.id}`}
                  className="block text-center text-xs font-display py-2 mx-3 mb-3 rounded border transition-colors hover:bg-[rgba(245,192,78,.12)]"
                  style={{ color: "var(--gold)", borderColor: "rgba(245,192,78,.4)", letterSpacing: 1, textDecoration: "none" }}>
                  🏆 VIEW CERTIFICATE
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
